import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';

import { RouterStateService } from 'src/lib/router';
import { defer, of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

import { AdobeAnalyticsService } from './AdobeAnalyticsService';
import { AnalyticsEvent, AnalyticsEventType } from './model';
import { Router } from '@angular/router';



@Injectable()
export class AnalyticsEffects {

  constructor(
    private actions$: Actions,
    private analyticsService: AdobeAnalyticsService,
    private routerState: RouterStateService,
    private router: Router
  ) { }


  routeChange$ = createEffect(() => {
    return defer(() => of(null)).pipe(
      switchMap(() => this.routerState.state$.pipe(
        filter(state => !state.initial),
        tap(state => {
          this.analyticsService.track(new AnalyticsEvent({
            type: AnalyticsEventType.Navigation,
            pageName: `${this.getRootPageName()} > ${state.data['analytics'].pageName}`
          }));
        })
      ))
    );
  }, { dispatch: false });

  private getRootPageName(): string {
    const lang = this.getCurrentLanguage();
    const nav = this.router.getCurrentNavigation();
    const pageName = nav?.extras?.state?.pageName;
    return pageName ? pageName : `cpc.ca: > ${lang} > My Profile 2.0`;
  }

  private getCurrentLanguage(): string {
    let lang = 'en';
    if (typeof window.localStorage !== 'undefined' && window.localStorage != null) {
      lang = localStorage.getItem('locale');
    }
    return lang;
  }

}
